/** Validation error types for user access validation failures */
export const PORTAL_ACCESS_VALIDATION_ERRORS = {
  /** User's email domain is not authorized for the portal */
  INVALID_EMAIL_DOMAIN: 'invalid-email-domain',
  /** User provisioning failed during account setup */
  PROVISIONING_FAILED: 'provisioning-failed',
  /** A user with the same email already exists for the institution with a different Okta account */
  DUPLICATE_EMAIL: 'duplicate-email',
  /** The student's account exists but has been deactivated */
  INACTIVE_USER: 'inactive-user',
  /** The student is not a member of a required Okta group (Student Portal or institution group) */
  NOT_IN_PORTAL_GROUP: 'not-in-portal-group',
} as const;

export type PortalAccessValidationError = (typeof PORTAL_ACCESS_VALIDATION_ERRORS)[keyof typeof PORTAL_ACCESS_VALIDATION_ERRORS];
